import { STEPS, STUDENT_PROFILE_BOARD_ID, PRESENTING_BOARD_ID } from "../constants";
import { PREVIEW_BOARD_ID } from "@app/routes/treatmentV3/constants";
import { COLORS } from "@amplio-utils/textCoding/constant";

export const EMPTY_WORDS_STATE = {
  wordId: undefined,
  studentWord: "",
  currentStep: STEPS.WRITING,
  mistakeData: {},
  isLoadingMistakesData: false,
  
  coding: {
    selectedLetters: [0],
    letters: { },
    sketchColor: { value: COLORS[6] },
  },
  
  isSubmit: false,

  isListen: false, // 1
  isEcho: false, // 2
  isSpell: false, // 3
  
  isWrite: false, // 5
  isCoding: false, // 5
};

export const SPELLING_EMPTY_STATE = {
  analiticsTrackEventFunc: undefined,
  requiredClearState: false,
  currentWordId: 0,
  therapistWordId: 0,
  isShowCompleteDialog: false,

  wordsState: {},
  accuracy: undefined,
  isEsperanza: false,
  isComplete: false,
  isWaiting: false,
  measurementUUID: undefined,

  isUpdatingMeasurements: false,
  isUpdatingMeasurementsError: false,
};

export const SPELLING_ADAPTER_SYSTEM_USERS = [
  { id: PREVIEW_BOARD_ID, name: "PREVIEW", ...SPELLING_EMPTY_STATE },
  { id: PRESENTING_BOARD_ID, name: "PRESENTING", ...SPELLING_EMPTY_STATE },
  { id: STUDENT_PROFILE_BOARD_ID, name: "PROFILE", ...SPELLING_EMPTY_STATE },
];

export const SPELLING_ADAPTER_SYSTEM_INITIAL_STATE = {
  ids: [PREVIEW_BOARD_ID, PRESENTING_BOARD_ID, STUDENT_PROFILE_BOARD_ID],
  entities: {
    [PREVIEW_BOARD_ID]: SPELLING_ADAPTER_SYSTEM_USERS[0],
    [PRESENTING_BOARD_ID]: SPELLING_ADAPTER_SYSTEM_USERS[1],
    [STUDENT_PROFILE_BOARD_ID]: SPELLING_ADAPTER_SYSTEM_USERS[2],
  },
};
